import React, { useState, useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { InputDropdown } from "../../../common/native";
import PhotoGalleryScreen from "./PhotoGalleryScreen";
import HomeGallery from "../gallery/HomeGallery";
import { mixpanel } from "../../../../utils/mixpanel";
import { SessionContext } from "../../../../contexts";

type Mode = "Patient Photos" | "Before/After";

const UnifiedGalleryScreen: React.FC = () => {
  const [mode, setMode] = useState<Mode>("Patient Photos");
  const session = React.useContext(SessionContext)?.session;

  useEffect(() => {
    mixpanel.track("Gallery Page Viewed", {
      initial_mode: mode,
      screen_name: "UnifiedGalleryScreen",
      "Clinic Name": session?.clinicName ?? "clinic not found",
    });
  }, []); // Empty dependency array means this runs once when component mounts

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <View style={styles.dropdownContainer}>
          <InputDropdown
            name={""}
            value={mode}
            selections={["Patient Photos", "Before/After"]}
            onSelect={(value) => setMode(value as Mode)}
          />
        </View>
      </View>

      <View style={styles.content}>
        {mode === "Patient Photos" ? <PhotoGalleryScreen /> : <HomeGallery />}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "#fff" },
  topBar: {
    width: "100%",
    paddingHorizontal: 16,
    paddingTop: 12,
    zIndex: 2,
    elevation: 2,
    position: "relative",
  },
  dropdownContainer: {
    width: 175,
    alignSelf: "flex-end",
  },
  content: {
    flex: 1,
  },
});

export default UnifiedGalleryScreen;
